import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import GroupIcon from '@mui/icons-material/Group';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BadgeIcon from '@mui/icons-material/Badge';
import FaceIcon from '@mui/icons-material/Face';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import ElderlyIcon from '@mui/icons-material/Elderly';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PsychologyIcon from '@mui/icons-material/Psychology';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import BusinessIcon from '@mui/icons-material/Business';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StoreIcon from '@mui/icons-material/Store';
import ChurchIcon from '@mui/icons-material/Church';
import FoundationIcon from '@mui/icons-material/Foundation';
import FactoryIcon from '@mui/icons-material/Factory';
import GavelIcon from '@mui/icons-material/Gavel';
import ScienceIcon from '@mui/icons-material/Science';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import HubIcon from '@mui/icons-material/Hub';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';

export const ICON_MAP: Record<string, React.ComponentType<{ fontSize?: any; style?: React.CSSProperties }>> = {
  person: PersonIcon,
  people: PeopleIcon,
  group: GroupIcon,
  supervisor_account: SupervisorAccountIcon,
  badge: BadgeIcon,
  face: FaceIcon,
  child_care: ChildCareIcon,
  elderly: ElderlyIcon,
  volunteer_activism: VolunteerActivismIcon,
  support_agent: SupportAgentIcon,
  psychology: PsychologyIcon,
  accessibility: AccessibilityNewIcon,
  work: WorkIcon,
  school: SchoolIcon,
  local_hospital: LocalHospitalIcon,
  business: BusinessIcon,
  business_center: BusinessCenterIcon,
  apartment: ApartmentIcon,
  account_balance: AccountBalanceIcon,
  store: StoreIcon,
  church: ChurchIcon,
  foundation: FoundationIcon,
  factory: FactoryIcon,
  gavel: GavelIcon,
  science: ScienceIcon,
  agriculture: AgricultureIcon,
  hub: HubIcon,
  corporate_fare: CorporateFareIcon,
  diversity: Diversity3Icon,
  family: FamilyRestroomIcon,
  star: StarIcon,
  favorite: FavoriteIcon,
};

interface IconPickerProps {
  value: string;
  onChange: (icon: string) => void;
  color?: string;
}

export function renderIcon(name: string, style?: React.CSSProperties) {
  const IconComponent = ICON_MAP[name] ?? PersonIcon;
  return <IconComponent fontSize="small" style={style} />;
}

export default function IconPicker({ value, onChange, color = '#6366f1' }: IconPickerProps) {
  return (
    <div>
      <label className="text-[12px] ml-[2px] text-[var(--text-color)] block mb-[6px]">Icon</label>
      <div className="flex flex-wrap gap-[4px] max-h-[160px] overflow-y-auto p-[4px] rounded-[5px] bg-[var(--bg-input)]">
        {Object.entries(ICON_MAP).map(([key, IconComponent]) => (
          <button
            key={key}
            type="button"
            title={key.replace(/_/g, ' ')}
            onClick={() => onChange(key)}
            className="w-[34px] h-[34px] flex items-center justify-center rounded-[5px] transition-colors flex-shrink-0"
            style={{
              backgroundColor: value === key ? color : 'transparent',
              border: value === key ? `2px solid ${color}` : '2px solid transparent',
            }}>
            <IconComponent
              fontSize="small"
              style={{ color: value === key ? '#fff' : 'var(--text-color)', opacity: value === key ? 1 : 0.6 }}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
